// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"5e31f9ad","232":"6ac17167","237":"81236583","357":"0ef80509","526":"6b2ae829","787":"28cee758","872":"319ba3b5"}[chunkId] + ".chunk.js";
};